import { z } from "zod";

/**
 * Exercise History validation schema
 * Validates the entire exerciseHistory category
 */

export const exerciseHistoryValidation = z.object({
  exercises: z.array(z.object({
    type: z.string().min(1),
    frequency: z.string().min(1),
    intensity: z.string().min(1),
    device: z.string(),
    limitations: z.string(),
  })),
});

export default exerciseHistoryValidation;
